import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { fetchFeedOperators } from '../../../actions/feed.actions';
import { selectFeedOperators } from '../../../reducers';
import { FeedOperatorHint } from '../../../services/feed.service';
import { AppState } from '../../../../reducers';
import { NomObjectTypes } from '../../../constants';

@Component({
  selector: 'app-feed-query-hints-popup',
  templateUrl: './feed-query-hints-popup.component.html',
  styleUrl: './feed-query-hints-popup.component.scss',
  standalone: false,
})
export class FeedQueryHintsPopupComponent {
  @Input() objectTypeId: NomObjectTypes;

  feedOperators$: Observable<Array<FeedOperatorHint>>;

  @Output() close = new EventEmitter<void>();
  @Output() hintSelected = new EventEmitter<string>();

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    if (this.objectTypeId) {
      this.store.dispatch(
        fetchFeedOperators({ objectTypeId: this.objectTypeId }),
      );
      this.feedOperators$ = this.store.select(selectFeedOperators);
    }
  }

  onCloseClick() {
    this.close.emit();
  }

  addOperator(operatorName: any) {
    this.hintSelected.emit(operatorName);
  }
}
